import React, { Fragment } from 'react';
import {
  Filter,
  Edit,
  SimpleForm,
  List,
  Create,
  Datagrid,
  FunctionField,
  TextInput,
  TextField,
  EditButton,
  DisabledInput,
  ArrayInput,
  SimpleFormIterator,
  CardActions,
  ListButton,
} from 'react-admin';

import Button from '@material-ui/core/Button';
import BulkDeleteButton from './ui/BulkDeleteButton';

import { appOptions } from '../config/app';
import ArrayChipField from './ui/ArrayChipField';

const YoutubeFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

const YoutubeBulkActionButtons = props => (
  <Fragment>
      <BulkDeleteButton {...props} />
  </Fragment>
);

const YoutubeActions = ({ basePath, data, resource }) => (
  <CardActions>
    {data && 
      <Button style={{marginRight: '10px'}} variant="outlined" color="primary" href={getShowUrl(data.id)} target="_blank" rel="noopener noreferrer">
        Link
      </Button>}
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

function getCurrentSiteBaseUrl(language) {
  switch (language) {
    case 'mk':
      return 'https://grid.mk';
    case 'bg':
      return 'https://topvesti.bg';
    case 'au':
      return 'https://1000.news';
    case 'mk2':
      return 'https://vesti.mk';
    case 'rs':
      return 'https://topvesti.rs';
    default:
      return null;
  }
}

function getShowUrl(show_id, language) {
  if (show_id) {
    const lang = language || localStorage.getItem(appOptions.languageKey);
    const site = getCurrentSiteBaseUrl(lang);
    if (site) {
      return `${site}/videos/youtube/${show_id}/`;
    }
  }
  return '#';
}

export const YoutubeList = props => (
  <List title="Youtube shows" bulkActionButtons={<YoutubeBulkActionButtons />} {...props} filters={<YoutubeFilter />} perPage={50}>
    <Datagrid>
      <TextField source="id" sortable={false} />
      <TextField source="name" />
      <TextField source="channel_id" />
      <ArrayChipField source="keywords" sortable={false} />
      <FunctionField
        sortable={false}
        source="id"
        label="Link"
        render={(record, source) => (
          <a href={getShowUrl(record['id'], props.language)} target="_blank" rel="noopener noreferrer">
            {record['id']}
          </a>
        )}
      />
      <EditButton />
    </Datagrid>
  </List>
);

export const YoutubeEdit = props => (
  <Edit title="Youtube show" actions={<YoutubeActions />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="name" />
      <TextInput source="channel_id" />
      <ArrayInput source="keywords">
        <SimpleFormIterator>
          <TextInput label=" " />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);

export const YoutubeCreate = props => (
  <Create title="Add Youtube Show" actions={<YoutubeActions />} {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="name" />
      <TextInput source="channel_id" />
      <ArrayInput source="keywords">
        <SimpleFormIterator>
          <TextInput label="Keyword" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/youtube.js